import axios from 'axios'
import { API_URL } from '@/constants'

// const API_URL = process.env.API_URL || 'http://10.5.0.2:4000/api/v1'
// const API_URL = process.env.API_URL || 'https://api.back-of-the-envelope.com/api/v1'

export const HTTP = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer {token}'
  }
})
